module.exports = __webpack_public_path__ + "img/entry-kit.18e14b0c.svg";